import { useMutation } from "@tanstack/react-query";
import { authorize } from "../api/auth";

export default function useLogin() {
    return useMutation({
        mutationFn: authorize,
        onSuccess: (data) => {
            localStorage.setItem("Token", data.token)
            localStorage.setItem("User-Id", data.user_id)
        }
    })
}